import { render, staticRenderFns } from "./view_vendor_mgmt.vue?vue&type=template&id=02583056&scoped=true"
import script from "./view_vendor_mgmt.vue?vue&type=script&lang=js"
export * from "./view_vendor_mgmt.vue?vue&type=script&lang=js"
import style0 from "./view_vendor_mgmt.vue?vue&type=style&index=0&id=02583056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02583056",
  null
  
)

export default component.exports